import { NOTES_MAX_LENGTH } from '../../constants';

import { TextAreaInput, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { NOTES_ROWS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceNotesField: FunctionComponent<Props> = ({
    className = '',
    notes,
    onChange,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    const handleChange = (value: string) => onChange({ notes: value });

    return (
        <VerticalContainer className={`${styles.serviceNotesField} ${className}`} testId={testId}>
            <Wrapper className={styles.label}>{t.LOG_SERVICE_NOTES}</Wrapper>

            <TextAreaInput
                className={styles.notesInput}
                onChange={handleChange}
                placeholder={t.LOG_SERVICE_NOTES_PLACEHOLDER}
                rows={NOTES_ROWS}
                testId={`${testId}-input`}
                value={notes}
            />

            <Wrapper className={styles.counter}>
                {t.LOG_SERVICE_NOTES_COUNTER({ count: notes.length, max: NOTES_MAX_LENGTH })}
            </Wrapper>
        </VerticalContainer>
    );
};

export default ServiceNotesField;
